
import HttpService from './HttpService';
import { ApiResponse } from '../../subscription/models/ApiResponse';
import Entity from 'src/modules/organization/models/Entity';
import Subscription from '../../subscription/models/Subscription';
import Request from '../../subscription/models/Request'
import subscriptionStatus from '../../subscription/models/SubscriptionStatus';
import HttpCallConfig from '../models/HttpCallConfig'

import User from '../../subscription/models/User'



class SubscriptionRequestService {
  private static instance: SubscriptionRequestService

  private httpService = HttpService.Instance;

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  public async getRequestsList(data:any) {
    const response: ApiResponse = await this.getRequestsData(data);
    const subscriptions: Array<Promise<Request>> = response.subscriptions.map((subscription: Subscription) => this.getRequest(subscription));
    return Promise.all(subscriptions);
  }

  public async getRequestsize() {
    const response: any = await this.getRequestsData();
    return response.length;
  }

  public async getEntity(entityId: string, environmentId?: any) {
    const response: Response = await this.httpService.get(process.env.REACT_APP_API_URL + "entity/" + entityId + (environmentId ? "?environmentId=" + environmentId : ""), { enforceErrorPage: true });
    return response.json();
  }

  public async getRequest(subscription: Subscription) {
    const myentity: Entity = await this.getEntity(subscription.entityId)
    const request: Request = {
      id: subscription.id,
      time: subscription.createdOn,
      entityName: myentity.name,
      assetName: subscription.product.asset.name,
      enviromentName: subscription.environment.name
    }
    return request
  }

  public async getAsset(assetId: string) {
    const assetdata = await this.httpService.get(process.env.REACT_APP_API_URL + '/assets/' + assetId);
    return assetdata.json();
  }

  public async getUser(userId: string) {
    const response: Response = await this.httpService.get(process.env.REACT_APP_API_URL + "users/", { enforceErrorPage: true });
    const data = await response.json();
    return data.users.find((user: User) => user.id === userId)
  }

  public async getSubscription(subscriptionId: string) {
    const response: Response = await this.httpService.get(process.env.REACT_APP_API_URL + "subscriptions/" + subscriptionId, { enforceErrorPage: true });
    return response.json();
  }

  public async getRequestsData(data?:any) {
    const response: Response = await this.httpService.get(process.env.REACT_APP_API_URL + "subscription-validations?stateId=1" +( data.environmentId !== undefined? "&environmentId=" + data.environmentId:"" )+( data.page !== undefined ? "&page=" + data.page:"") + (data.pagesize !== undefined ? "&pagesize=" + data.pagesize: ""), { enforceErrorPage: false });
    return response.json();
  }

  public async putRoles(roles: any[], subscriptionId: string) {
    const httpCallConfig = new HttpCallConfig;
    httpCallConfig.successMessage = 'roles updated';
    return this.httpService.put(process.env.REACT_APP_API_URL + "subscriptions/" + subscriptionId + "/roles", { roles }, httpCallConfig);
  }

  public async getAllSubscriptions(data: any) {
    const response = await this.httpService.get(process.env.REACT_APP_API_URL + "subscription-validations?assetId=" + data.asset + "&entityId=" + data.entityid + "&stateId=1&stateId=3&stateId=4" + "&environmentId=" + data.enviromentId + "&page=" + data.page + "&pagesize=" + data.pagesize, { enforceErrorPage: true });
    const responsedata = await response.json();
    return { subscriptions: await Promise.all(responsedata.subscriptions.map((subscription: Subscription) => this.getSubscriptionStatus(subscription))), page: responsedata._page };
  }

  public async getSubscriptionStatus(subscription: Subscription) {
    const myentity: Entity = await this.getEntity(subscription.entityId)
    const request: subscriptionStatus = {
      id: subscription.id,
      date: subscription.updatedOn,
      entityName: myentity.name,
      assetName: subscription.product.asset.name,
      enviromentName: subscription.environment.name,
      status: subscription.state.name,
      roles: subscription.roles
    }
    return request
  }

  public async getAssetList() {
    const response: Response = await this.httpService.get(process.env.REACT_APP_API_URL + "assets?view=name", { enforceErrorPage: true });
    return response.json();
  }

  public async aproveRequest(id: string, aproved: boolean, remark: string) {
    const data = {
      id: aproved ? 3 : 2,
      remark
    }
    const httpCallConfig = new HttpCallConfig;
    httpCallConfig.successMessage = 'state updated'
    return await this.httpService.post(process.env.REACT_APP_API_URL + "subscriptions/" + id + "/state", data, httpCallConfig)
  }

  public cancelSubscription(subscriptionId: string) {
    const data = {
      id: 6,
      remark: 'Subscription cancelled'
    };

    const httpCallConfig = new HttpCallConfig();
    httpCallConfig.successMessage = 'Subscription cancelled'
    return this.httpService.post(process.env.REACT_APP_API_URL + "subscriptions/" + subscriptionId + "/state", data, httpCallConfig)
  }
}

export default SubscriptionRequestService;


// WEBPACK FOOTER //
// ./src/modules/core/services/SubscriptionRequestService.tsx